// =====================================
//  上傳稿件 modal
//
//  @author: Gray
//  @time 2016 / 09 / 01
// =====================================

window.InifECMobileApp.directive('uploadOrderitemFile', ['$rootScope', '$ngModal', '$timeout',
    function ($rootScope, $ngModal, $timeout) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var submit = function() {

                var userfileurl = $scope.form.userfileurl;

                if(!userfileurl) {
                    $scope.isUrlError = true;
                    return;
                }

                userfileurl = addhttp(userfileurl);

                if(!isUrl(userfileurl)) {
                    $scope.isUrlError = true;
                    return;
                }

                $scope.isUrlError = false;
                ($scope.callback) && $scope.callback(userfileurl);
                closeModal();
            }

            // -------------------------------
            // 離開上傳稿件
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            //  開啟教學圖片 modal
            // -------------------------------
            var openGuideImagePlayer = function(showTypeString) {

                var showType;

                switch(showTypeString) {
                    case 'dropbox_link':
                        showType = 0;
                        break;
                    case 'dropbox_share':
                        showType = 1;
                        break;
                    case 'google_link':
                        showType = 2;
                        break;
                    case 'google_share':
                        showType = 3;
                        break;
                }


                $rootScope.$broadcast('OPEN_GUIDE_IMAGE_PLAYER_MODAL', {
                    showType: showType
                });
            }

            // -------------------------------
            //  開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('upload-orderitem-file-modal');
            }

            // -------------------------------
            //  關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('upload-orderitem-file-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_UPLOAD_ORDERITEM_FILE_MODAL', function(event, data) {
                
                if(data) {
                    $scope.form.userfileurl = data.orderitem.userfileurl;
                    $scope.callback = data.callback;

                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.form = {
                userfileurl: ''
            }
            $scope.orderitem;

            /*==========================
                Methods
            ==========================*/
            $scope.submit = submit;
            $scope.cancel = cancel; // 離開上傳稿件
            $scope.callback;
            $scope.openGuideImagePlayer = openGuideImagePlayer;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/upload_orderitem_file.html";
        _dir.controller = controller;

        return _dir;
    }]
);